import { getExemptPages } from '../constants/acceptConditions';

export const pageExemptFromConditionAcceptance = (route: string) => {
  return getExemptPages().includes(route);
};
